export default __webpack_public_path__ + "static/bca-e00ce2c5ffa970a98a05dbbc66e44250.jpg";